import { getURLParams } from './getURLParams';
import { ELanguage } from '@/consts/language';

function setDir() {
  // 获取语音参数
  const locale = getURLParams(window.location.href, 'locale');
  let isRtl = false;
  // 定义一个从语言代码到文本方向的映射
  // eslint-disable-next-line default-case
  switch (locale) {
    case ELanguage.ar:
      isRtl = true;
      break;
  }
  console.log('isRtl', isRtl, locale);
  // 获取文档的 <html> 元素
  const htmlElement = document.documentElement;
  htmlElement.setAttribute('dir', isRtl ? 'rtl' : 'ltr');
}
setDir();
